module.exports = __webpack_public_path__ + "img/744.61a3f13c.jpg";